// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/routers'
import ElementUI from 'element-ui'//引入饿了么ui
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import vuelidate from 'vuelidate'
import store from './store'
//import GeminiScrollbar from 'vue-gemini-scrollbar'
import icons from './icons'
import 'babel-polyfill'
import JrComponent from './components/componentsjr'
import plTable from 'pl-table'
import 'pl-table/themes/index.css' // 引入样式（必须引入)，请查看webpack是否配置了url-loader对woff，ttf文件的引用,不配置会报错哦
import 'pl-table/themes/plTableStyle.css' // 默认表格样式很丑 引入这个样式就可以好看啦（如果你不喜欢这个样式，就不要引入，不引入就跟ele表格样式一样）
import '@/assets/iconfont/iconfont.css' // 引入阿里矢量图标字体

Vue.use(plTable);


Vue.use(ElementUI, { locale })
Vue.use(vuelidate)
Vue.use(JrComponent)
Vue.use(plTable);
//Vue.use(GeminiScrollbar)
Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js